<template>
  <div>
    <transition name="sarpa-fade">
      <div
        v-if="storage"
        class="sarpa-loader"
        :class="contain ? 'sarpa-loader--contain' : 'sarpa-loader--fullscreen'"
      >
        <div class="sarpa-loader__badge">
          <!-- outer arc, clockwise -->
          <span class="sarpa-loader__ring"></span>
          <!-- inner arc, counter-clockwise -->
          <span class="sarpa-loader__ring sarpa-loader__ring--inner"></span>
          <!-- the favicon, rounded into a disc -->
          <span class="sarpa-loader__disc">
            <img :src="favicon" alt="Loading" class="sarpa-loader__icon" />
          </span>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import favicon from "@/assets/images/sarpaico.png";
export default {
  props: ["storage", "contain"],
  data() {
    return {
      favicon: favicon,
    };
  },
};
</script>
<style scoped>
.sarpa-loader {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(3px);
}

.sarpa-loader--fullscreen {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
}

/* keeps the loader inside its parent when <PageLoader contain /> is used */
.sarpa-loader--contain {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
}

.sarpa-loader__badge {
  position: relative;
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sarpa-loader__ring {
  position: absolute;
  top: 0;
  left: 0;
  width: 84px;
  height: 84px;
  border: 3px solid rgba(66, 125, 45, 0.14);
  border-top-color: #427d2d;
  border-radius: 50%;
  animation: sarpaSpin 0.85s linear infinite;
}

.sarpa-loader__ring--inner {
  top: 9px;
  left: 9px;
  width: 66px;
  height: 66px;
  border-color: transparent;
  border-bottom-color: #68d389;
  border-width: 2px;
  animation: sarpaSpin 1.4s linear infinite reverse;
}

.sarpa-loader__disc {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 6px 18px rgba(31, 42, 36, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  animation: sarpaPulse 1.5s ease-in-out infinite alternate;
}

/* the source favicon only ships 16/32/48px frames, so it is held at 36px to stay sharp */
.sarpa-loader__icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: contain;
  display: block;
}

@keyframes sarpaSpin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes sarpaPulse {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.06);
  }
}

.sarpa-fade-enter-active,
.sarpa-fade-leave-active {
  transition: opacity 0.2s ease;
}

.sarpa-fade-enter,
.sarpa-fade-leave-to {
  opacity: 0;
}

@media (prefers-reduced-motion: reduce) {
  .sarpa-loader__ring,
  .sarpa-loader__ring--inner,
  .sarpa-loader__disc {
    animation: none;
  }
}
</style>
